/**
 *
 * @param {*} array: string[]
 * @returns {*} string[]
 */
export const sortArrayOfStringAlphabetically = (array) => {
  return array.sort((a, b) => {
    return a.localeCompare(b, 'pt-BR', { sensitivity: 'base' })
  })
}




// WEBPACK FOOTER //
// ./src/utils/array.js